import { SVGProps } from "react";

export function SbpIcon({ isDisabled, ...props }: SVGProps<SVGSVGElement> & { isDisabled?: boolean }) {
  const getFill = (originalColor: string) => {
    if (isDisabled) return "#969696";
    return originalColor;
  };

  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 3.61133L2.02372 7.20208V9.39234L0.00236741 12.976L0 3.61133Z" fill={getFill("#5B57A2")} />
      <path d="M7.77148 5.89537L9.66778 4.74163L13.5487 4.73804L7.77148 8.25124V5.89537Z" fill={getFill("#D90751")} />
      <path d="M7.75894 3.58965L7.76966 8.34369L5.74121 7.10645V0L7.75894 3.58965Z" fill={getFill("#FAB718")} />
      <path d="M13.5468 4.73759L9.66582 4.74118L7.75894 3.58965L5.74121 0L13.5468 4.73759Z" fill={getFill("#ED6F26")} />
      <path d="M7.76966 12.9961V10.6896L5.74121 9.47583L5.74232 16.5893L7.76966 12.9961Z" fill={getFill("#63B22F")} />
      <path d="M9.66181 11.8527L2.02358 7.20208L0 3.61133L13.5392 11.848L9.66181 11.8527Z" fill={getFill("#1487C9")} />
      <path d="M5.74365 16.5891L7.77071 12.9958L9.66227 11.8526L13.5397 11.8479L5.74365 16.5891Z" fill={getFill("#017F36")} />
      <path d="M0.00439453 12.9755L5.7604 9.47526L3.82525 8.29663L2.02574 9.39176L0.00439453 12.9755Z" fill={getFill("#984995")} />
    </svg>
  );
}
